import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useAppSelector } from "../redux";
import { ROUTES } from "../constants";

const ProtectedRoute: React.FC = () => {
  const isAuthenticated = useAppSelector((state) => state.auth.isAuthenticated);

  if (!isAuthenticated) {
    return <Navigate to={ROUTES.LOGIN} replace />;
  }

  return <Outlet />;
};

export default ProtectedRoute;
